var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_c('file-upload',{on:{"upload":_vm.prepareToUpload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }